// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JDXu_","top":"styles_top__ue8Ex","left":"styles_left__24_1q","description":"styles_description__2ZMFu"};